var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.943 18.762 28.482.642C28.896.213 29.379 0 29.93 0c.552 0 1.035.214 1.45.641.413.428.62.936.62 1.524s-.207 1.096-.62 1.523l-18.988 19.67c-.414.428-.897.642-1.449.642s-1.034-.214-1.448-.641L.596 14.165a2.025 2.025 0 0 1-.595-1.524 2.215 2.215 0 0 1 .647-1.523c.414-.428.905-.641 1.474-.641.57 0 1.06.213 1.475.641l7.346 7.644Z",
  fill: "currentColor"
})));
export default SvgCheck;